import {findWork, FindWorkResponseData} from "../../../utils/awsAmplifyUtil";
import useFetchAllQuery, {Status, useFetchAllQueryHelper} from "../../../hooks/useFetchAllQuery";

export interface UseWorkInstanceByClass {
  onChange: (newData: FindWorkResponseData<'instance'>[], newStatus: Status) => void;
  workClassIds: string[];
  enableAutoFetch?: boolean;
  initialStatus?: Status;
}

export function useWorkInstanceByClass(params: UseWorkInstanceByClass) {
  const result = useFetchAllQuery({
    queryFn: (query) => findWork(
      'instance',
      {
        version: "work-user",
        queryAttr: {
          'class-id': {
            $in: params.workClassIds
          }
        }
      },
      query
    ),
    needToFetchMore: (data, limit) => Object.entries(data?.items ?? {}).length === limit,
    enableAutoFetch: params.enableAutoFetch,
  });
  const helperResult = useFetchAllQueryHelper({
    onChange: params.onChange,
    data: result.data,
    status: result.status,
    initialStatus: params.initialStatus,
  })

  return {
    ...result,
    ...helperResult,
  };
}
